import { render, staticRenderFns } from "./Ledes.vue?vue&type=template&id=9924e224&"
import script from "./Ledes.vue?vue&type=script&lang=js&"
export * from "./Ledes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports